// extracted by mini-css-extract-plugin
export default {"header4":"X3pXJr"};